// Core
import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Components
import { Crumbs, PageHead, SideTabs } from "components/AtomsV2";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";

// Pages
import ManageOutsideTempLoads from "pages/ManageHP/OutsideTempLoads";
import ManageWaterMassUsageForecast from "pages/ManageHP/WaterMassUsageForecast";

function ManageHP() {
  const { t } = useTranslation(["internalLoads", "community", "sidenav"]);
  const community = useSelector(selectCurrentCommunity);
  const [tab, setTab] = useState("temp");

  const tabs = [
    { id: "temp", icon: "thermostat", label: t("pages.outside_temp_loads.title") },
    {
      id: "water",
      icon: "water_drop",
      label: t("pages.water_mass_usage_forecast.title", {
        defaultValue: "Previsão Massa de Água",
      }),
    },
  ];

  return (
    <div>
      <HelpFloatingButtonV2 helpScreen="loads" />
      <Crumbs
        items={[
          { label: community?.name || "—" },
          { label: t("internalloads", { ns: "sidenav", defaultValue: "Medições Internas" }) },
          { label: t("sidenav.hp", { ns: "community", defaultValue: "Bombas de Calor" }) },
        ]}
      />
      <PageHead
        title={t("sidenav.hp", { ns: "community", defaultValue: "Bombas de Calor" })}
        subtitle={t("pages.outside_temp_loads.subtitle")}
      />
      <SideTabs items={tabs} active={tab} onChange={setTab}>
        {tab === "temp" && <ManageOutsideTempLoads noWrapper />}
        {tab === "water" && <ManageWaterMassUsageForecast noWrapper />}
      </SideTabs>
    </div>
  );
}

export default ManageHP;
